import BaseFeature from '../../foundation/base/base';

class Menu extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.menu = this.el;
		this.body = window.features.dom.body;
		this.subMenuTrigger = this.el.querySelectorAll('[data-js="subMenuTrigger"]');
		this.subMenuAccessibility = this.el.querySelectorAll('[data-js="subMenuTrigger"]');
		this.menuBackBtn = this.el.querySelector('[data-js="menuBackBtn"]');
		this.mobileCloseBtn = this.el.querySelector('[data-js="mobileCloseBtn"]');
		this.secondaryLinks = document.querySelectorAll('.m-menu-list__link--secondary');
		this.addClick();
	}


	addClick() {
		if (this.subMenuTrigger) {
			// Expand submenu
			this.subMenuTrigger.forEach((element) => {
				element.addEventListener('click', () => {
					// Collapsing search if menu is triggered
					const searchTrigger = document.querySelector('.m-search.is-active');
					if (searchTrigger) {
						searchTrigger.classList.remove('is-active');
					}
					document.querySelectorAll('.m-menu-list__item').forEach((elm) => {
						if (elm !== element.parentNode) {
							elm.classList.remove('is-active');
						}
					});
					element.parentNode.classList.toggle('is-active');
				});
			});
		}

		if (this.menuBackBtn) {
			// Back button on submenu
			this.menuBackBtn.addEventListener('click', () => {
				document.querySelector('.m-menu-list__item.is-active').classList.remove('is-active');
			});
		}

		if (this.mobileCloseBtn) {
			// Close mobile menu
			this.mobileCloseBtn.addEventListener('click', () => {
				document.querySelector('.m-menu.is-open').classList.remove('is-open');
				document.querySelector('body').classList.remove('is-filter-menu');
			});
		}
		window.addEventListener('keyup', (e) => {
			const isFocused = document.activeElement === this.subMenuTrigger;
			if (isFocused && e.keyCode === 13) {
				e.preventDefault();
				// Trigger the button element with a click
				this.subMenuTrigger.click();
			}
		});
		this.subMenuAccessibility.forEach((elem) => {
			elem.addEventListener('click', () => {
				let elementState = elem.getAttribute('aria-expanded');
				if (elementState === 'true') {
					elementState = 'false';
					this.secondaryLinks.forEach((element) => {
						element.setAttribute('tabindex', '-1');
					});
				} else {
					elementState = 'true';
					this.secondaryLinks.forEach((element) => {
						element.setAttribute('tabindex', '0');
					});
				}
				elem.setAttribute('aria-expanded', elementState);
			});
		});

		this.secondaryLinks.forEach((elem) => {
			elem.setAttribute('tabindex', '-1');
		});
	}
}

export default Menu;
